import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { AnimatedSection, AnimatedText, itemVariants, sectionVariants } from '../animations';

const API_BASE_URL = 'https://smartsolutionslk.com/api/api.php';

const BlogHighlightSection = () => {
  const [latestPosts, setLatestPosts] = useState([]);

  useEffect(() => {
    const fetchLatestPosts = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}?resource=blogs`);
        const allPosts = await response.json();
        // Take only the 3 most recent posts for the homepage highlight
        setLatestPosts(allPosts.slice(0, 3));
      } catch (error) {
        console.error("Failed to fetch latest blog posts:", error);
      }
    };

    fetchLatestPosts();
  }, []);

  // Don't render the section if there are no posts to show
  if (latestPosts.length === 0) {
    return null;
  }

  return (
    <AnimatedSection id="blog-highlight" className="bg-white dark:bg-black text-black dark:text-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <AnimatedText text="From Our Blog." className="text-4xl md:text-6xl font-bold" variants={sectionVariants}/>
          <p className="text-lg text-gray-600 dark:text-gray-400 mt-4">
            Explore our latest articles and insights on technology and innovation.
          </p>
        </div>

        <motion.div 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
        >
          {latestPosts.map((post) => (
            <motion.div 
              key={post.id} 
              variants={itemVariants}
              className="group flex flex-col h-full bg-gray-50 dark:bg-gray-800 rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300"
            >
              <Link to={`/blog/${post.slug}`}>
                <div className="relative w-full" style={{ paddingTop: '56.25%' }}>
                  <img 
                    src={post.image_url} 
                    alt={post.title} 
                    className="absolute top-0 left-0 w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </Link>
              <div className="p-6 flex flex-col flex-grow">
                <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">{post.date}</p>
                <h3 className="text-2xl font-bold mb-3 flex-grow">
                  <Link to={`/blog/${post.slug}`} className="hover:text-cyan-400 transition-colors duration-300">{post.title}</Link>
                </h3>
                <div className="mt-auto">
                  <Link to={`/blog/${post.slug}`} className="font-semibold text-cyan-500 dark:text-cyan-400 hover:underline">
                    Read More &rarr;
                  </Link>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <div className="text-center mt-16">
            <Link 
                to="/blog"
                className="inline-block px-10 py-4 bg-cyan-500 text-black rounded-full font-semibold text-lg hover:bg-cyan-400 transition-colors duration-300 transform hover:scale-105"
            >
                Explore Our Blog
            </Link>
        </div>
      </div>
    </AnimatedSection>
  );
};

export default BlogHighlightSection;
